
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniahireserviceinbhosaripune() {



    const cardData =
    {
        keyword: 'Urbania hire service in Bhosari Pune    ',
        heading: 'Amruta Travels: Urbania hire service in Bhosari Pune  ',
        headingDescription: 'Amruta Travels offers Urbania Hire Service in Bhosari Pune, providing a premium and reliable solution for group travel, including corporate trips, family outings, airport transfers, school excursions, and weekend getaways. Our 13-seater and 17-seater Force Urbania vans feature spacious interiors, air-conditioning, and modern amenities to ensure a smooth and enjoyable journey. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels makes Urbania hire in Bhosari Pune safe, convenient, and hassle-free.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Urbania hire service in Bhosari Pune",
    "description": "Premium Urbania hire service in Bhosari Pune offering safe, comfortable, and reliable transport for families, corporate teams, and groups. Vehicles are fully AC, spacious, and maintained to ensure smooth city, airport, and outstation travel."
  },
  {
    "name": "Urbania on rent in Bhosari",
    "description": "Urbania on rent in Bhosari providing convenient travel solutions for airport transfers, factory staff, corporate outings, weddings, and family trips. Flexible rental plans available with professional drivers."
  },
  {
    "name": "Force Urbania hire Bhosari Pune",
    "description": "Force Urbania hire in Bhosari Pune ideal for group travel, corporate meetings, and VIP transfers. Equipped with AC, luxury seating, ample luggage space, and experienced chauffeurs."
  },
  {
    "name": "Urbania Rental service Bhosari",
    "description": "Urbania rental service in Bhosari offering reliable bookings for daily, weekly, and outstation travel with transparent pricing and quality service."
  },
  {
    "name": "Urbania Bus hire in Bhosari",
    "description": "Urbania bus hire in Bhosari for weddings, corporate events, industrial staff transportation, picnics, and family trips. Spacious interiors and comfortable AC travel guaranteed."
  },
  {
    "name": "Urbania on rent near Bhosari Pune",
    "description": "Urbania on rent near Bhosari Pune for quick accessibility from MIDC, Moshi, Pimpri Chinchwad, and nearby industrial areas."
  },
  {
    "name": "13 seater Urbania hire Bhosari",
    "description": "13 seater Urbania hire in Bhosari perfect for small families, corporate teams, and airport transfers with comfortable pushback seats and AC interiors."
  },
  {
    "name": "17 seater Urbania on rent Bhosari",
    "description": "17 seater Urbania on rent in Bhosari for larger groups, corporate trips, weddings, and factory staff transport with ample luggage space and smooth ride quality."
  },
  {
    "name": "Luxury Urbania hire Bhosari Pune",
    "description": "Luxury Urbania hire in Bhosari Pune for premium corporate travel, VIP transport, and luxury family trips with elegant interiors and experienced drivers."
  },
  {
    "name": "AC Urbania Bus hire Bhosari",
    "description": "AC Urbania bus hire in Bhosari ensuring cool, comfortable travel in all seasons for both short and long-distance journeys."
  },
  {
    "name": "Force Urbania 17 seater Bhosari",
    "description": "Force Urbania 17 seater in Bhosari designed for group outings, corporate travel, and outstation tours with professional service and premium AC interiors."
  },
  {
    "name": "Urbania hire near MIDC Bhosari",
    "description": "Urbania hire near MIDC Bhosari providing convenient transportation for factory staff, industrial employees, and corporate visits."
  },
  {
    "name": "Urbania on rent near Pimpri Chinchwad",
    "description": "Urbania on rent near Pimpri Chinchwad for easy connectivity to industrial zones, offices, and residential areas."
  },
  {
    "name": "Urbania Rental near Moshi",
    "description": "Urbania rental near Moshi offering hassle-free bookings for families, corporate staff, and outstation trips with AC comfort."
  },
  {
    "name": "Urbania Bus hire near Alandi Road",
    "description": "Urbania bus hire near Alandi Road for group travel, factory staff transport, and special events with reliable service."
  },
  {
    "name": "Urbania on rent near Chakan Road",
    "description": "Urbania on rent near Chakan Road suitable for industrial and corporate transport, outstation tours, and airport transfers."
  },
  {
    "name": "Urbania hire Bhosari for corporate travels",
    "description": "Urbania hire in Bhosari for corporate travel, office staff transport, meetings, conferences, and seminars with premium service."
  },
  {
    "name": "Urbania on rent Bhosari for factory staff transport",
    "description": "Urbania on rent in Bhosari for factory staff and industrial employee transport ensuring punctuality, safety, and comfort."
  },
  {
    "name": "Urbania hire Bhosari for family trips",
    "description": "Urbania hire in Bhosari for family trips, weekend getaways, and long-distance travel with spacious seating and AC comfort."
  },
  {
    "name": "Urbania rental Bhosari for outstation",
    "description": "Urbania rental in Bhosari for outstation travel to Lonavala, Mahabaleshwar, Shirdi, Mumbai, and other destinations with reliable service."
  },
  {
    "name": "Urbania Bus hire Bhosari for Wedding",
    "description": "Urbania bus hire in Bhosari for weddings and events with luxury interiors, comfortable seating, and professional drivers."
  },
  {
    "name": "Urbania airport pickup from Bhosari",
    "description": "Urbania airport pickup service from Bhosari ensuring timely arrivals, spacious luggage area, and comfortable travel to Pune Airport."
  },
  {
    "name": "Urbania Pune Airport drop from Bhosari",
    "description": "Urbania Pune Airport drop service from Bhosari with punctual departures, AC comfort, and experienced drivers."
  },
  {
    "name": "Urbania corporate hire Bhosari Pune",
    "description": "Urbania corporate hire in Bhosari Pune for office staff, client visits, and corporate events with luxury AC vehicles."
  },
  {
    "name": "Urbania Bus hire Bhosari for industrial companies",
    "description": "Urbania bus hire in Bhosari for industrial companies, factory transport, and staff movement with safe and comfortable travel."
  },
  {
    "name": "Urbania hire Bhosari price",
    "description": "Urbania hire price in Bhosari with affordable and transparent rates for group, corporate, and family travel."
  },
  {
    "name": "Urbania hire Bhosari per km rate",
    "description": "Urbania hire in Bhosari available on per km basis for local, airport, and outstation travel with flexible pricing."
  },
  {
    "name": "Affordable Urbania rental Bhosari",
    "description": "Affordable Urbania rental in Bhosari providing premium AC comfort at budget-friendly rates."
  },
  {
    "name": "Cheap Urbania on rent Bhosari",
    "description": "Cheap Urbania on rent in Bhosari for economical group travel without compromising comfort or safety."
  },
  {
    "name": "Best Urbania hire service Bhosari",
    "description": "Best Urbania hire service in Bhosari offering well-maintained vehicles, experienced drivers, and punctual service."
  },
  {
    "name": "Book Urbania hire in Bhosari",
    "description": "Book Urbania hire in Bhosari with easy online booking, flexible schedules, and reliable service."
  },
  {
    "name": "Online Urbania booking Bhosari Pune",
    "description": "Online Urbania booking in Bhosari Pune for hassle-free reservations and premium service."
  },
  {
    "name": "Urbania cab service Bhosari",
    "description": "Urbania cab service in Bhosari for city travel, airport transfers, and local errands with comfort and convenience."
  },
  {
    "name": "3 Seater Urbania Hire Service in Bhosari Pune",
    "description": "3 Seater Urbania hire service in Bhosari Pune for small groups, families, and VIP travel."
  },
  {
    "name": "Luxury Force Urbania Rental Bhosari",
    "description": "Luxury Force Urbania rental in Bhosari offering elegant interiors, plush seating, AC comfort, and professional chauffeur service."
  },
  {
    "name": "Urbania Airport Transfer from Bhosari Pune",
    "description": "Urbania Airport transfer from Bhosari Pune for punctual, safe, and comfortable airport pickups and drops with luxury AC vehicles."
  }
],
"tableData": [
  ["Urbania hire service in Bhosari Pune", "Urbania on rent in Bhosari"],
  ["Force Urbania hire Bhosari Pune", "Urbania Rental service Bhosari"],
  ["Urbania Bus hire in Bhosari", "Urbania on rent near Bhosari Pune"],
  ["13 seater Urbania hire Bhosari", "17 seater Urbania on rent Bhosari"],
  ["Luxury Urbania hire Bhosari Pune", "AC Urbania Bus hire Bhosari"],
  ["Force Urbania 17 seater Bhosari", "Urbania hire near MIDC Bhosari"],
  ["Urbania on rent near Pimpri Chinchwad", "Urbania Rental near Moshi"],
  ["Urbania Bus hire near Alandi Road", "Urbania on rent near Chakan Road"],
  ["Urbania hire Bhosari for corporate travels", "Urbania on rent Bhosari for factory staff transport"],
  ["Urbania hire Bhosari for family trips", "Urbania rental Bhosari for outstation"],
  ["Urbania Bus hire Bhosari for Wedding", "Urbania airport pickup from Bhosari"],
  ["Urbania Pune Airport drop from Bhosari", "Urbania corporate hire Bhosari Pune"],
  ["Urbania Bus hire Bhosari for industrial companies", "Urbania hire Bhosari price"],
  ["Urbania hire Bhosari per km rate", "Affordable Urbania rental Bhosari"],
  ["Cheap Urbania on rent Bhosari", "Best Urbania hire service Bhosari"],
  ["Book Urbania hire in Bhosari", "Online Urbania booking Bhosari Pune"],
  ["Urbania cab service Bhosari", "3 Seater Urbania Hire Service in Bhosari Pune"],
  ["Luxury Force Urbania Rental Bhosari", "Urbania Airport Transfer from Bhosari Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Trusted Urbania Hire Service in Bhosari Pune",
    "WhyChoosedescription": "Amruta Travels offers Urbania Hire Service in Bhosari Pune, providing stylish, comfortable, and dependable travel solutions for corporate trips, family outings, and group travel."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Family, and Event Travel",
    "WhyChoosedescription": "Whether it’s a corporate meeting, family outing, wedding transport, or city sightseeing, our Urbania rentals in Bhosari ensure a smooth and comfortable journey."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "Urbania vehicles feature plush seating, generous legroom, air conditioning, wide windows, and ample luggage space, making them perfect for short city rides and long-distance trips."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "All Urbania rentals come with trained and courteous drivers who ensure punctuality, safety, and a pleasant travel experience throughout Bhosari and Pune."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels provides competitive and transparent pricing for Urbania rentals in Bhosari, giving you excellent value for money without any hidden charges."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
    "WhyChoosedescription": "Our Urbania vehicles are regularly serviced and sanitized to maintain high standards of hygiene, safety, and passenger comfort."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Route Options",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations with customized routes to suit your travel plan within Bhosari, Pune, or nearby destinations."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking an Urbania hire service in Bhosari Pune is simple and hassle-free with Amruta Travels. Our support team assists you at every step for a seamless experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I book an Urbania hire service in Bhosari Pune?',
    answer: 'You can book an Urbania hire service in Bhosari Pune by contacting Amruta Travels online, via phone, or by visiting our office. Our team will assist you throughout the booking process.'
  },
  {
    question: 'Is Urbania suitable for corporate travel from Bhosari?',
    answer: 'Yes, Urbania is ideal for corporate travel, offering spacious seating, air conditioning, and comfort for employees and clients traveling from Bhosari.'
  },
  {
    question: 'Can I hire Urbania in Bhosari for outstation trips?',
    answer: 'Yes, we provide Urbania hires from Bhosari for both local and outstation travel, ensuring a smooth and comfortable journey.'
  },
  {
    question: 'Does the Urbania hire include a driver?',
    answer: 'Yes, every Urbania hire includes a professional and experienced driver for safe and hassle-free travel.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained?',
    answer: 'Absolutely. All Urbania vehicles are regularly serviced, cleaned, and sanitized to maintain hygiene, safety, and passenger comfort.'
  },
  {
    question: 'What is the cost of Urbania hire service in Bhosari Pune?',
    answer: 'The rental cost depends on distance, duration, and type of travel. Contact Amruta Travels for a transparent and customized quote.'
  },
  {
    question: 'Can I customize pickup and drop-off locations in Bhosari?',
    answer: 'Yes, we offer flexible pickup and drop-off options and route customization based on your travel needs.'
  },
  {
    question: 'Why choose Amruta Travels for Urbania hire service in Bhosari Pune?',
    answer: 'Amruta Travels offers well-maintained Urbania vehicles, professional drivers, transparent pricing, and reliable support, ensuring a premium travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rakesh Pawar',
    role: 'Corporate Executive, Bhosari',
    text: 'We hired an Urbania from Bhosari for a corporate event. The vehicle was spacious, clean, and comfortable. The driver was professional and punctual. Excellent service by Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Kavita Jadhav',
    role: 'Family Traveler, Bhosari',
    text: 'Booked an Urbania hire service in Bhosari for a family outing. The ride was smooth, comfortable, and hassle-free. Highly recommend Amruta Travels!',
    rating: 5
  }
];

























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire Service in Bhosari Pune",
  "image": "https://bushireinpune.com/assets/images/urbania-bhosari.jpg",
  "description": "Urbania on rent in Bhosari Pune with Amruta Travels. Rent 13 & 17 seater Force Urbania vans for corporate travel, factory staff transport, airport transfers, family trips, weddings, and outstation travel. Service areas include MIDC Bhosari, Pimpri Chinchwad, Moshi, Alandi Road, and Chakan Road with professional drivers and affordable per km rates.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2150"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6200",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/urbania-hire-bhosari"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Urbania Hire Service in Bhosari Pune | Force Urbania Rental | Amruta Travels</title>
  <meta
    name="description"
    content="Urbania on rent in Bhosari Pune with Amruta Travels. Rent 13 & 17 seater Force Urbania vans for corporate travel, factory staff transport, airport transfers, family trips, weddings, and outstation travel at affordable rates."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/118.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniahireserviceinbhosaripune;